import { render, staticRenderFns } from "./OpeningBalanceRow.vue?vue&type=template&id=0931abfb"
import script from "./OpeningBalanceRow.vue?vue&type=script&lang=js"
export * from "./OpeningBalanceRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports